module.exports = __webpack_public_path__ + "static/hero-2b7a0a0f54e132154d9943e794de155d.png";